import React, { useContext } from 'react'
import { SceneContext } from '../../context/sceneContext'
import Direction from '../aframe/objects/Direction'
import Hotspot from '../aframe/objects/Hotspot'
import Information from '../aframe/objects/Information'
import MultipleChoice from '../aframe/objects/MultipleChoice'

const Elements = () => {
  const { scene } = useContext(SceneContext)

  const getElements = () => {
    switch (scene.kind) {
      case 'INFORMATION':
        return <Information />
      case 'HOTSPOT':
        return <Hotspot />
      case 'MPC':
        return <MultipleChoice />
      case 'DIRECTION':
        return <Direction />
      case 'TRANSITION':
      default:
        return null
    }
  }
  return (
    <>
      {/* Place elements here */}
      {getElements()}
    </>
  )
}

export default Elements
